(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15805],{

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, displayParams = _param.displayParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams",
        "displayParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: displayParams ? (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            src: url
        }, displayParams)) : url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 15805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18422);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_BlogCommon_Article_ContentfulParser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92870);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89494);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_get_segment_text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54255);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, formattedDescription = param.formattedDescription, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sectionTitleContainer), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[type], className, titleStyle),
        id: title ? slugify__WEBPACK_IMPORTED_MODULE_3___default()(title) : null,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    "data-title": true,
                    isBold: true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: titleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: titleSegments.length === 1 ? (0,_utils_get_segment_text__WEBPACK_IMPORTED_MODULE_10__/* .getSegmentText */ .d)(title) : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                            ket: segment,
                            "data-title": true,
                            isBold: true,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                            mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            variant: "span",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                            children: (0,_utils_get_segment_text__WEBPACK_IMPORTED_MODULE_10__/* .getSegmentText */ .d)(segment)
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    "data-subtitle": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                        "data-description": true,
                        size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            formattedDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    "data-description": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_BlogCommon_Article_ContentfulParser__WEBPACK_IMPORTED_MODULE_11__["default"], {
                        document: formattedDescription
                    })
                })
            })),
            secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: secondTitleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    "data-second-subtitle": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    "data-second-description": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    titleStyle: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    secondTitle: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    secondSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    secondDescription: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    titleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    secondTitleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (SectionTitle);


/***/ }),

/***/ 54255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getSegmentText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getSegmentText = function(text) {
    var parts = text.split(/(~~.*?~~)/g);
    return parts.map(function(part) {
        var isAlpa = /^~~.*~~$/.test(part);
        if (isAlpa) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-title-alpha": true,
                style: {
                    display: "inline"
                },
                children: part.slice(2, -2)
            }, part);
        }
        return part;
    });
};


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(13107), __webpack_require__.e(17396)]).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType",
                            "tableText"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType, tableText = ref3.tableText;
                        return (tableContent || tableText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableText ? (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .extractContentfulTableData */ .cc)(tableText) : tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ })

}]);